export function prospectReducer(state = {
    RESUME : {},
    ACTIONS : {},
    LIST: {},
},{
    type,
    payload
}){
    
    switch(type){
        case "NEW_PROSPECT":            
                
            return {[payload.id] : payload, ...state};

        case "GET_ACTIONS_PROSPECT":
            let list = Object.assign({},state)
            list.ACTIONS = Object.assign(list.ACTIONS, payload)
            return list;

        case "GET_RESUME_PROSPECTS":
            let list2 = Object.assign({},state)
            list2.RESUME = payload
            return list2;

        case "GET_PROSPECTS_TYPE":
            let list3 = Object.assign({}, state)
            list3.LIST[payload.pType] = {...payload}
            if( payload.pType === "Prospect" ) {
                list3.RESUME = payload.list
            }
            return list3
        default:
            return state;
    }
    
}